<script>
import Toc from "svelte-toc";

import { page } from "$app/stores";

import { Section, Seo, CodeInjector, PostHeader } from "$lib/components";
import { m } from "$lib/paraglide/messages.js";

let { data } = $props();
const { post: Post } = $derived(data);
const { metadata } = $derived(data);
const { locale } = $derived(data);

// OG image: vite-imagetools generates a 1200px webp for og:image meta tags
const ogImageModules = import.meta.glob(`$assets/images/*.{jpg,jpeg,png}`, {
  eager: true,
  import: "default",
  query: { w: 1200, format: "webp", quality: 80 },
});

const ogImageSrc = $derived.by(() => {
  const key = metadata.seoImage || metadata.image;
  if (!key) return null;
  return ogImageModules[`/src/assets/images/${key}`] ?? null;
});
</script>

<Seo
  url={$page.url.pathname}
  title={metadata.title}
  locale={locale}
  image={ogImageSrc}
  ogType="article"
  description={metadata.summary}
  creator={metadata.author}
  createdAt={metadata.createdAt}
  publishedAt={metadata.publishedAt}
  updatedAt={metadata.updatedAt}
  keywords={metadata.keywords}
  wordCount={metadata.timeToRead?.words || 0}
  ldjson={["website", "organization", "blogposting", "breadcrumb"]}
  breadcrumbs={[
    { title: m.nav_posts(), href: locale === "tr" ? "/tr/makaleler/" : "/posts/" },
    { title: metadata.title, href: $page.url.pathname },
  ]}
  ldjsonAdditional={[...(metadata.faq?.length ? ["faqPage"] : []), ...(metadata.howTo?.length ? ["howTo"] : [])]}
  ldjsonTemplate={{
    ...(metadata.faq?.length ? { faqPage: { questions: metadata.faq } } : {}),
    ...(metadata.howTo?.length ? { howTo: { steps: metadata.howTo } } : {}),
  }}
/>
<main id="main-content">
  <Section class="container">
    <div class="grid grid-cols-1 lg:grid-cols-6 lg:gap-10">
      <article class="prose max-w-none flex-col md:prose-lg lg:col-span-4 dark:prose-invert" data-speakable>
        <PostHeader locale={locale} metadata={metadata} />
        <CodeInjector>
          <Post />
        </CodeInjector>
      </article>
      <div class="bg-base-2 lg:col-span-2">
        <Toc
          --toc-font="8pt var(--font-sans)"
          --toc-title-font="10pt var(--font-sans) bold"
          --toc-title-margin="0 0 1rem"
          --toc-desktop-aside-margin="10em 0 0 0"
          --toc-desktop-sticky-top="1em"
          --toc-desktop-max-width="100%"
          --toc-active-bg="var(--color-accent-a3)"
          --toc-active-color="var(--color-accent-9)"
          --toc-li-hover-color="var(--color-accent-9)"
        >
          {#snippet title_snippet()}
            <h3 class="toc-exclude mb-4 text-base font-semibold">{m.table_of_contents()}</h3>
          {/snippet}
        </Toc>
      </div>
    </div>
  </Section>
</main>
